<button
    mat-icon-button
    [disabled]="!canFavorite || isLoading"
    [matTooltip]="isFavorite ? 'Remove from favourites' : 'Add to favourites'"
    (click)="toggleFavorite()"
>
    <mat-icon
        [svgIcon]="
            isFavorite ? 'heroicons_solid:star' : 'heroicons_outline:star'
        "
    ></mat-icon>
</button>
